// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/js/main.3a3c34f8.js";
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"a35e1278","133":"2ee8359c","182":"ba5be67f"}[chunkId] + ".chunk.js";
};